module.exports = __webpack_public_path__ + "img/cg.6344c363.svg";